/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclEntry {
    scope: string;

    protected setDiscriminator(type: string) {
        this.scope = type;
    }

    getFixupPrototypeFunction() { return DashboardDefinitionAclEntry.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclEntry>): DashboardDefinitionAclEntry {
        let obj = Object.assign(new DashboardDefinitionAclEntry(), model);
        DashboardDefinitionAclEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclEntry>): DashboardDefinitionAclEntry {
        if (!model) return null;
        return DashboardDefinitionAclEntry.newInstance(<DashboardDefinitionAclEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclEntry) {
        if (!obj) return;

        models.DashboardDefinitionAclEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclEntry): boolean {
        switch (obj.scope)
        {
            case "account":
                Object.setPrototypeOf(obj, models.DashboardDefinitionAclEntryAccount.prototype);
                break;
            case "global":
                Object.setPrototypeOf(obj, models.DashboardDefinitionAclEntryGlobal.prototype);
                break;
            case "tenant":
                Object.setPrototypeOf(obj, models.DashboardDefinitionAclEntryTenant.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof DashboardDefinitionAclEntry)[] {
        return [
            models.DashboardDefinitionAclEntryAccount,
            models.DashboardDefinitionAclEntryGlobal,
            models.DashboardDefinitionAclEntryTenant,
        ];
    }

    fixupFields() {
    }

    users: Array<string>;

    user_groups: Array<string>;

    /**
     * Actions granted for matching users
     */
    granted: Array<string>;

    /**
     * Actions denied for matching users
     */
    denied: Array<string>;

}
